import { citiesWithoutDistricts } from '~/constants/common.ts';
import { TTobo } from './types';

export const getRegionsOptions = (toboData: TTobo[]) => {
  const uniqueRegions = toboData.reduce((acc: TTobo[], current: TTobo) => {
    const existing = acc.find((item) => item.regionid === current.regionid);
    if (!existing) {
      acc.push(current);
    }
    return acc;
  }, []);

  const kyivRegion = uniqueRegions.find(
    (region) => region.regionid === citiesWithoutDistricts.KYIV_REGION_CODE
  );

  const otherRegions = uniqueRegions
    .filter((region) => region.regionid !== citiesWithoutDistricts.KYIV_REGION_CODE)
    .map((region) => ({
      value: region.regionid?.toString(),
      label: region.regionname,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
  const kiyvOption = kyivRegion
    ? [{ value: kyivRegion?.regionid?.toString(), label: kyivRegion?.regionname }]
    : [];
  return [...kiyvOption, ...otherRegions];
};
